import React from "react";
import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import "./ButtonWithIcon.scss";

const ButtonWithIcon = ({
  icon,
  text,
  onClick = () => {}, // Default parameter
  className = "", // Default parameter
  disabled = false, // Default parameter
  type = "button", // Default to "button"
}) => {
  return (
    <button
      type={type} // Add type attribute here
      onClick={onClick}
      className={`button-with-icon ${className}`}
      disabled={disabled}
    >
      {icon && <Icon icon={icon} className="button-icon" />}
      {text}
    </button>
  );
};

ButtonWithIcon.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]), // Add type prop validation
};

export default ButtonWithIcon;
